import { render, staticRenderFns } from "./SMSGatewayRoot.html?vue&type=template&id=7ce5f648&external"
import script from "./SMSGatewayRoot.js?vue&type=script&lang=js&external"
export * from "./SMSGatewayRoot.js?vue&type=script&lang=js&external"
import style0 from "./SMSGatewayRoot.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports